import PropTypes from 'prop-types';
import interceptor from 'rest/interceptor';
import i18next from 'i18next';
const errorSlugRegexp = /^[A-Z0-9]+(?:_[A-Z0-9]+)*$/;
export default interceptor({
    contextTypes: {
        router: PropTypes.object.isRequired,
    },
    request(request) {
        return request;
    },
    response(response) {
        if (response.entity &&
            (response.entity.message || response.entity.error) &&
            (errorSlugRegexp.test(response.entity.message) ||
                errorSlugRegexp.test(response.entity.error))) {
            return Object.assign(Object.assign({}, response), { entity: Object.assign(Object.assign({}, response.entity), (response.entity.message === undefined
                    ? { error: i18next.t(response.entity.error) }
                    : { message: i18next.t(response.entity.message) })) });
        }
        return response;
    },
});
